import { Fragment, useEffect, useState } from "react";
import Select from "./Select";
import util from "../TesteNovoJSON/Util/util";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import utilNovo from "./utils";
import "./index.css";

function verificaModalidades(metas, realizados) {
    metas = Object.keys(metas).map(nome => nome);
    realizados = Object.keys(realizados).map(nome => nome);
    let novoArray = [...metas, ...realizados];
    novoArray = [...new Set(novoArray)];
    return novoArray.sort();
}

function constroiTabela(metas, realizados, campo) {
    let modalidades =  verificaModalidades(metas, realizados);

    let metaZerada = new Array(12).fill(0);
    let realizadoZerado = new Array(12).fill(0);

    let totalMesMeta = new Array(12).fill(0);
    let totalMesRealizado = new Array(12).fill(0);
    
    let tabela = modalidades.map((modalidade, indice) => {
        let m = metas.hasOwnProperty(modalidade) ? metas[modalidade][campo] : metaZerada;
        let r = realizados.hasOwnProperty(modalidade) ? realizados[modalidade][campo] : realizadoZerado;

        if(metas.hasOwnProperty(modalidade) === false && realizados.hasOwnProperty(modalidade) === false) return;

        let totalMeta = m.reduce((acc, atual) => acc + atual, 0);
        let totalRealizado = r.reduce((acc, atual) => acc + atual, 0);

        totalMesMeta.forEach((valor, mesIndice) => totalMesMeta[mesIndice] += m[mesIndice]);
        totalMesRealizado.forEach((valor, mesIndice) => totalMesRealizado[mesIndice] += r[mesIndice]);

        return(
            <>
            <tr>
                <td className="total" rowSpan={2}>{modalidade}</td>
                <td>Previsto</td>
                {m.map((valor, i) => <td>{utilNovo.formataNumero(valor)}</td>)}
                <td className="total">{utilNovo.formataNumero(totalMeta)}</td>
            </tr>
            <tr>
                <td>Realizado</td>
                {r.map((valor, i) => <td>{utilNovo.formataNumero(valor)}</td>)}
                <td className="total">{utilNovo.formataNumero(totalRealizado)}</td>
            </tr>
            </>
        )

    });

    let totalAnualMeta = totalMesMeta.reduce((acc, atual) => acc + atual, 0);
    let totalAnualRealizado = totalMesRealizado.reduce((acc, atual) => acc + atual, 0);

    let tabelaTotal = (
        <>
        <tr className="total">
            <td className="total" rowSpan={2}>{"Total"}</td>
            <td  className="total">Previsto</td>
            {totalMesMeta.map((valor, i) => <td className="total">{utilNovo.formataNumero(valor)}</td>)}
            <td className="total">{utilNovo.formataNumero(totalAnualMeta)}</td>
        </tr>
        <tr className="total">
            <td>Realizado</td>
            {totalMesRealizado.map((valor, i) => <td>{utilNovo.formataNumero(valor)}</td>)}
            <td>{utilNovo.formataNumero(totalAnualRealizado)}</td>
        </tr>
        </>
    )

    return [...tabela, tabelaTotal];

}

const NovoRelatorioMensal = (props) => {

    const [dados, setDados] = useState([]);
    const [campo, setCampo] = useState("matricula_regimental");

    useEffect(async () => {
        let dados = await util.fetchDados("janeiro", false);
        setDados(dados.dados);
    }, []);

    let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

    const selectCampo = (event) => {
        setCampo(event.target.value);
    }
    
    const exibeFiltros = () => {
        return(
            <div className="row">
                <div className="col-md-9">
                </div>
                <div className="col-md-3">
                    <Select select={selectCampo} campo="campos" idComponente="selectCampo" />
                </div>
            </div>
        )
    } 
    
    return(
        <Fragment>

            <Tabs defaultActiveKey={"DR"}>

                {dados.map((obj, i) => {

                    let unidade = utilNovo.verificaSiglaUnidade(obj.unidade);
                    let { metas, realizados } = obj;

                    return (
                        <Tab eventKey={unidade} title={unidade}>
                            
                            <Fragment>
                                <table border="1" className="table table-bordered table-hover table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th colSpan="15" className="text-center">{obj.unidade}</th>
                                        </tr>
                                        <tr>
                                            <td colSpan="15">
                                                {exibeFiltros()}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th rowSpan="15" colSpan="2">Modalidade</th>
                                            {meses.map(mes => <th><span style={{ textTransform: "uppercase" }}>{mes}</span></th>)}
                                            <th>TOTAL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {constroiTabela(metas, realizados, campo)}
                                    </tbody>
                                </table>
                            </Fragment>

                        </Tab>
                    )
                })}

            </Tabs>

        </Fragment>
    )
}

export default NovoRelatorioMensal;